module.exports = __webpack_public_path__ + "static/favicon-3fe49a38b358bd99c2b4cca806920182.ico";